const countryToLanguageMapping = {
    'ad': 'ca',
    'ae': 'ar',
    'af': 'fa',
    'ag': 'en',
    'ai': 'en',
    'al': 'sq',
    'am': 'hy',
    'an': 'nl',
    'ao': 'pt',
    'ar': 'es',
    'as': 'en',
    'at': 'de',
    'au': 'en',
    'aw': 'nl',
    'ax': 'sv',
    'ba': 'hr',
    'bb': 'en',
    'bd': 'en',
    'be': 'nl',
    'bf': 'fr',
    'bh': 'ar',
    'bi': 'fr',
    'bj': 'fr',
    'bl': 'fr',
    'bm': 'en',
    'bn': 'ms',
    'bo': 'es',
    'br': 'pt',
    'bs': 'en',
    'bt': 'en',
    'bv': 'no',
    'bw': 'en',
    'by': 'be',
    'bz': 'en',
    'ca': 'en',
    'cc': 'en',
    'cd': 'fr',
    'cf': 'fr',
    'cg': 'fr',
    'ch': 'de',
    'ci': 'fr',
    'ck': 'en',
    'cl': 'es',
    'cm': 'fr',
    'cn': 'zh-CN',
    'co': 'es',
    'cr': 'es',
    'cu': 'es',
    'cv': 'pt',
    'cx': 'en',
    'cy': 'el',
    'cz': 'cs',
    'dj': 'fr',
    'dk': 'da',
    'dm': 'en',
    'do': 'es',
    'dz': 'ar',
    'ec': 'es',
    'ee': 'et',
    'eg': 'ar',
    'eh': 'ar',
    'er': 'ar',
    'es': 'es',
    'et': 'en',
    'fi': 'fi',
    'fj': 'en',
    'fk': 'en',
    'fm': 'en',
    'ga': 'fr',
    'gb': 'en',
    'gd': 'en',
    'ge': 'ka',
    'gf': 'fr',
    'gg': 'en',
    'gh': 'en',
    'gi': 'en',
    'gl': 'da',
    'gm': 'en',
    'gn': 'fr',
    'gp': 'fr',
    'gq': 'es',
    'gr': 'el',
    'gs': 'en',
    'gt': 'es',
    'gu': 'en',
    'gw': 'pt',
    'gy': 'en',
    'hk': 'en',
    'hm': 'en',
    'hn': 'es',
    'ht': 'fr',
    'ie': 'en',
    'il': 'en',
    'im': 'en',
    'in': 'hi',
    'io': 'en',
    'iq': 'ar',
    'ir': 'fa',
    'it': 'it',
    'je': 'en',
    'jm': 'en',
    'jo': 'ar',
    'jp': 'ja',
    'ke': 'sw',
    'kg': 'ru',
    'kh': 'en',
    'ki': 'en',
    'km': 'ar',
    'kn': 'en',
    'kp': 'ko',
    'kr': 'ko',
    'kw': 'ar',
    'ky': 'en',
    'kz': 'ru',
    'la': 'en',
    'lb': 'ar',
    'lc': 'en',
    'li': 'de',
    'lk': 'en',
    'lr': 'en',
    'ls': 'en',
    'lu': 'fr',
    'ly': 'ar',
    'ma': 'ar',
    'mc': 'fr',
    'md': 'ru',
    'me': 'sq',
    'mf': 'fr',
    'mg': 'fr',
    'mh': 'en',
    'ml': 'fr',
    'mm': 'en',
    'mo': 'pt',
    'mp': 'en',
    'mq': 'fr',
    'mr': 'ar',
    'ms': 'en',
    'mt': 'mt',
    'mu': 'fr',
    'mv': 'en',
    'mw': 'en',
    'mx': 'es',
    'my': 'ms',
    'mz': 'pt',
    'na': 'en',
    'nc': 'fr',
    'ne': 'fr',
    'nf': 'en',
    'ng': 'en',
    'ni': 'es',
    'no': 'no',
    'np': 'en',
    'nr': 'en',
    'nu': 'en',
    'nz': 'en',
    'om': 'ar',
    'pa': 'es',
    'pe': 'es',
    'pf': 'fr',
    'pg': 'en',
    'ph': 'en',
    'pk': 'en',
    'pl': 'pl',
    'pm': 'fr',
    'pn': 'en',
    'pr': 'es',
    'ps': 'ar',
    'pw': 'en',
    'py': 'es',
    'qa': 'ar',
    're': 'fr',
    'rs': 'sr',
    'rw': 'fr',
    'sa': 'ar',
    'sb': 'en',
    'sc': 'fr',
    'sd': 'ar',
    'se': 'sv',
    'sg': 'en',
    'sh': 'en',
    'si': 'sl',
    'sj': 'no',
    'sl': 'en',
    'sm': 'it',
    'sn': 'fr',
    'so': 'ar',
    'sr': 'nl',
    'st': 'pt',
    'ss': 'en',
    'sv': 'es',
    'sy': 'ar',
    'sz': 'en',
    'tc': 'en',
    'td': 'fr',
    'tf': 'fr',
    'tg': 'fr',
    'tj': 'ru',
    'tk': 'en',
    'tl': 'pt',
    'tm': 'en',
    'tn': 'ar',
    'to': 'en',
    'tt': 'en',
    'tv': 'en',
    'tw': 'zh-TW',
    'tz': 'sw',
    'ua': 'uk',
    'ug': 'en',
    'um': 'en',
    'us': 'en',
    'uy': 'es',
    'uz': 'en',
    'va': 'it',
    'vc': 'en',
    've': 'es',
    'vg': 'en',
    'vi': 'en',
    'vn': 'vi',
    'vu': 'en',
    'wf': 'fr',
    'ws': 'en',
    'ye': 'ar',
    'yt': 'fr',
    'za': 'af',
    'zm': 'en',
    'zw': 'en'
};

export default countryToLanguageMapping;